import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Component({
	selector: 'app-draggable-card',
	templateUrl: './draggable-card.component.html',
	styleUrls: ['./draggable-card.component.scss']
})
export class DraggableCardComponent implements OnInit {

	@Input() item: any;
	@Input() disabled: boolean;
	@Input() candelete: boolean;


	@Output() onRemoveItem = new EventEmitter<number>();
	@Output() onEditItem = new EventEmitter<number>();
	@Output() onDragItemStart = new EventEmitter<number>();
	@Output() onDragItemEnd = new EventEmitter<number>();
	@Output() onDragItemCanceled = new EventEmitter<number>();


	@ContentChild(TemplateRef) parentTemplate;

	@Input()
	cardid: string;


	index: number;

	constructor(private logger: NGXLogger) {
	}

	ngOnInit() {
	}

	onDragStart(event: DragEvent) {
		if (this.onDragItemStart) {
			this.onDragItemStart.emit();
		}
	}


	onDraggableCopied(event: DragEvent) {
	}

	onDraggableLinked(event: DragEvent) {
	}

	onDraggableMoved(event: DragEvent) {
	}

	onDragCanceled(event: DragEvent) {
		this.logger.log('onDragCanceled');
		if (this.onDragItemCanceled) {
			this.onDragItemCanceled.emit();
		}
	}

	onDragEnd(event: DragEvent) {
		console.log('dragend', event);
		if (this.onDragItemEnd) {
			this.onDragItemEnd.emit();
		}
	}

	removeItem() {
		this.onRemoveItem.emit();
	}

	editItem() {
		this.onEditItem.emit();
	}



}
